/**
 * PATH: packages/email-hub/src/feature/components/email-allocation/helpers.ts
 * FILE_ID: EMAILHUB-ALLOCATION-HELPER-001
 * PURPOSE: Pure labels, presentation metadata, and formatters for allocation controls.
 */
import type { ComponentType } from 'react'
import {
  Calendar,
  CalendarClock,
  CalendarDays,
  CircleSlash,
} from 'lucide-react'

import type { AllocationBucket } from './types'

export const BUCKET_META: Record<
  AllocationBucket,
  { label: string; icon: ComponentType<{ className?: string }>; tone: string }
> = {
  today: {
    label: 'Today',
    icon: Calendar,
    tone: 'bg-emerald-500/15 text-emerald-700 dark:text-emerald-300 border-emerald-500/40',
  },
  tomorrow: {
    label: 'Tomorrow',
    icon: CalendarClock,
    tone: 'bg-amber-500/15 text-amber-700 dark:text-amber-300 border-amber-500/40',
  },
  this_week: {
    label: 'This week',
    icon: CalendarDays,
    tone: 'bg-blue-500/15 text-blue-700 dark:text-blue-300 border-blue-500/40',
  },
  no_date: {
    label: 'No date',
    icon: CircleSlash,
    tone: 'bg-muted text-muted-foreground border-border',
  },
}

export const BUCKET_ORDER: AllocationBucket[] = [
  'today',
  'tomorrow',
  'this_week',
  'no_date',
]

export function allocationInitials(
  name?: string | null,
  email?: string | null,
): string {
  const raw = (name || email || '').trim()
  if (!raw) return '?'
  const parts = raw.split(/[\s@.]+/).filter(Boolean)
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase()
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase()
}

export function formatScheduledFor(scheduledFor?: string | null): string | null {
  if (!scheduledFor) return null
  return new Date(scheduledFor + 'T00:00:00').toLocaleDateString(
    undefined,
    { weekday: 'short', day: 'numeric', month: 'short' },
  )
}
